var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"HybridButtonOne-wrapper d-flex flex-row",style:({
  'background-color': _vm.backgroundColor,
  'color': _vm.color,
})},[_c('div',{staticClass:"text m-auto"},[_vm._t("default",[_vm._v("Button")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }